// extracted by mini-css-extract-plugin
export var askAiIcon = "_oz-k";
export var category = "_oz-a";
export var categoryHeader = "_oz-f";
export var container = "_oz-0";
export var group = "_oz-b";
export var groupItems = "_oz-g";
export var groupSeparator = "_oz-l";
export var highlight = "_oz-8";
export var loading = "_oz-1";
export var noResults = "_oz-3";
export var placeholder = "_oz-2";
export var resultContent = "_oz-5";
export var resultIcon = "_oz-d";
export var resultItem = "_oz-h";
export var resultMeta = "_oz-9";
export var resultSubtitle = "_oz-7";
export var resultSuffix = "_oz-j";
export var resultTitle = "_oz-6";
export var resultsList = "_oz-4";
export var searchGroup = "_oz-e";
export var selected = "_oz-i";
export var subgroup = "_oz-c";